
import React, { useEffect, useState } from 'react';
import { getImageDefault, ImageTypes } from '../image-gallery.utils';
import { ImageView } from '../image-view/image-view';
import styles from './gallery-slider.module.scss';
import cl from 'classnames';
import { Button } from '@touche-lts/panel-ui/dist';
import { IconArrowDropdownDown } from 'assets/icons';
import { IconCancel } from "assets/icons/svg";

const GallerySliderComponent = (props) => { // TODO-A To add correct model here
  const {
    objects = [],
    relatedMedia = [],
    thumbnailWidth = 163,
    thumbnailMargin = 20,
    maxContainerWidth = 500,
    onRelatedMediaClick,
    style,
    className,
    onOpenModal
  } = props;

  const imagesLength = objects.length;
  const mediaLength = relatedMedia.length;
  const thumbnailsLength = imagesLength + mediaLength;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [thumbnailOffset, setThumbnailOffset] = useState(0);

  const isCurrentIndexFirst = currentIndex === 0;
  const isCurrentIndexLast = currentIndex === thumbnailsLength - 1;

  useEffect(() => {
    const thumbnailsContainerWidth = ((thumbnailWidth + thumbnailMargin) * thumbnailsLength) - thumbnailMargin;
    const canTranslate = thumbnailsContainerWidth > maxContainerWidth;
    if (!canTranslate) return;
    setThumbnailOffset(
      (maxContainerWidth - thumbnailsContainerWidth) / (thumbnailsLength - 1) * currentIndex
    );
  }, [currentIndex]);

  const handlePrevClick = () => {
    setCurrentIndex(Math.max(0, currentIndex - 1));
  };
  const handleNextClick = () => {
    setCurrentIndex(Math.min(thumbnailsLength - 1, currentIndex + 1));
  };
  const handleRelatedMediaClick = (project: any, index: number) => {
    setCurrentIndex(index);
    if (onRelatedMediaClick) onRelatedMediaClick(project);
  };

  const [videoURL, setVideoURL] = useState('');

  const openModal = (videoUrl: string): void => {
    setVideoURL(videoUrl);
  };

  const onCloseModal = (): void => {
    setVideoURL('');
  };

  return (
    <>
    <div
      className={cl(styles.thumbnails, className)}
      style={style}
    >

      <div
        className={styles.thumbnailsContainer}
        style={{
          transform: `translateX(${thumbnailOffset}px)`,
          transition: 'all .6s'
        }}
      >

        {objects.map((obj, index) => {
          return (
            <div
              key={obj.image.id}
              style={{ marginLeft: thumbnailMargin }}
              onClick={() => {
                if (obj.image.url.includes('.mp4')) { // TODO-A We may support more video formats in future
                  openModal(obj.image.url);
                  return;
                }
                setCurrentIndex(index);
                if (obj.onClick) obj.onClick();
              }}
            >
              <ImageView
                image={obj.image}
                width={thumbnailWidth}
                onOpenModal={onOpenModal}
              />

              {obj.label && <label className={styles.label}>{obj.label}</label>}
            </div>
          );
        })}

        {relatedMedia.map((project, index) => {
          return (
            <div
              key={project.id}
              style={{ marginLeft: thumbnailMargin }}
              onClick={() => handleRelatedMediaClick(project, imagesLength + index)}
            >
              <ImageView
                image={getImageDefault(project.images, ImageTypes.PORTRAIT)}
                width={thumbnailWidth}
              />
              <div className={styles.playButton}><span><span>▶</span></span></div>
            </div>
          );
        })}

      </div>

      <Button
        className={cl(styles.prevButton)}
        onClick={handlePrevClick}
        disabled={isCurrentIndexFirst}
      >
        <IconArrowDropdownDown />
      </Button>

      <Button
        className={cl(styles.nextButton)}
        onClick={handleNextClick}
        disabled={isCurrentIndexLast}
      >
        <IconArrowDropdownDown />
      </Button>

    </div>
    <>
      {!!videoURL && (
        <div className={styles.containerModal}>
          <button className={styles.closeBtnModal} onClick={onCloseModal}>
           <IconCancel height={48} width={48}  fill="white"  />
          </button>
          <div className={styles.videoWrapModal}>
            <video controls autoPlay>
              <source src={videoURL} />
              <p>
                To view this video please enable JavaScript, and consider upgrading to a web browser that
                <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
              </p>
            </video>
          </div>
        </div>
      )}
    </>
    </>
  );
};

const GallerySlider = GallerySliderComponent;
export { GallerySlider };
